import { URL_SEARCH_KEY } from "constants/url_query_keys";

export const getSearchQuery = (urlParams: URLSearchParams) => {
  return decodeURIComponent(urlParams.get(URL_SEARCH_KEY) || "");
};
